var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "../../Tracking", "../SearchTeaser/SearchTeaser", "./SearchTeasersList.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("../../Tracking"), require("../SearchTeaser/SearchTeaser"), require("./SearchTeasersList.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.Tracking, global.SearchTeaser, global.SearchTeasersList);
    global.SearchTeasersList = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty3, _react, _propTypes, _Tracking, _SearchTeaser, _SearchTeasersList) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _SearchTeaser = _interopRequireDefault(_SearchTeaser);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var videosColors = ['#274A39', '#4C336B', '#9F3166', '#8D5515', '#016B79'];

  var SearchTeasersList = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(SearchTeasersList, _Component);

    var _super = _createSuper(SearchTeasersList);

    function SearchTeasersList(props) {
      var _this;

      (0, _classCallCheck2.default)(this, SearchTeasersList);
      _this = _super.call(this, props);

      switch (props.kind) {
        case 'VIDEOS':
          _this.teasers = props.teasers.map(function (teaser, index) {
            if (videosColors[index]) {
              return _objectSpread(_objectSpread({}, teaser), {}, {
                bgColor: videosColors[index],
                withLogo: true
              });
            }

            return teaser;
          });
          break;

        default:
          _this.teasers = props.teasers;
          break;
      }

      return _this;
    }

    (0, _createClass2.default)(SearchTeasersList, [{
      key: "render",
      value: function render() {
        var trackingEnabled = this.props.trackingEnabled;
        return /*#__PURE__*/_react.default.createElement(_SearchTeasersList.StyledTeasersList, null, /*#__PURE__*/_react.default.createElement(_SearchTeasersList.StyledContainer, null, this.teasers.map(function (teaser, index) {
          var tracking = SearchTeasersList.tracking(trackingEnabled, teaser.title);
          return /*#__PURE__*/_react.default.createElement(_SearchTeasersList.StyledCard, {
            key: teaser.url,
            index: index
          }, /*#__PURE__*/_react.default.createElement(_SearchTeaser.default, _objectSpread(_objectSpread({}, teaser), {}, {
            tracking: tracking
          })));
        })), this.teasers.filter(function (teaser, index) {
          return index >= 4;
        }).map(function (teaser) {
          var tracking = SearchTeasersList.tracking(trackingEnabled, teaser.title);
          return /*#__PURE__*/_react.default.createElement(_SearchTeasersList.StyledRow, {
            key: "responsive-".concat(teaser.url)
          }, /*#__PURE__*/_react.default.createElement(_SearchTeaser.default, _objectSpread(_objectSpread({}, teaser), {}, {
            tracking: tracking
          })));
        }));
      }
    }]);
    return SearchTeasersList;
  }(_react.Component);

  (0, _defineProperty3.default)(SearchTeasersList, "tracking", function (trackingEnabled, title) {
    return trackingEnabled ? function () {
      (0, _Tracking.send)({
        target: null,
        click_name: title,
        click_type: 'navigation'
      });
    } : function () {};
  });
  SearchTeasersList.propTypes = {
    kind: _propTypes.default.string.isRequired,
    teasers: _propTypes.default.arrayOf(_propTypes.default.shape({
      bgColor: _propTypes.default.string,
      className: _propTypes.default.string,
      image: _propTypes.default.string,
      title: _propTypes.default.string.isRequired,
      url: _propTypes.default.string.isRequired,
      withLogo: _propTypes.default.bool
    })),
    trackingEnabled: _propTypes.default.bool
  };
  SearchTeasersList.defaultProps = {
    kind: '',
    teasers: [],
    trackingEnabled: false
  };
  var _default = SearchTeasersList;
  _exports.default = _default;
});